import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
//import { useHistory } from 'react-router-dom';
import MUIDataTable from "mui-datatables";
//import SearchIcon from "@mui/icons-material/Search"; 
import {SearchIcon, DeleteIcon} from "@material-ui/icons/Search"; 
import axios from "axios";

import {
  Card,
  CardContent,
  Typography,
  Button,
  Modal,
  Box,
  IconButton
} from '@material-ui/core';



const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const PagosTable = props => {
  const { className, ...rest } = props;
  
  const columns = [
  { name: "nombres", label: "Nombre" },
  { name: "apellidos", label: "Apellidos" },
  { name: "nombreEmpresa", label: "Empresa" },
  { name: "email", label: "Email" },
  { name: "status", label: "Status", options: { customBodyRender: (value) => (value==="completed" ? "Pagado" : "No Pagado")} },
  
  { 
    name: "amount", 
    label: "Monto (MXN)", 
    options: { 
      customBodyRender: (value) => 
        new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(value) 
    } 
  },
  { name: "paquete", label: "Paquete", options: { customBodyRender: (value) => (value ? "Si" : "No") } },
  
  { name: "requiereFactura", label: "Requiere Factura", options: { customBodyRender: (value) => (value ? "Si" : "No") } },
  { name: "paymentDate", label: "Fecha de Pago", options: { customBodyRender: (value) => new Date(value).toLocaleString() } },
  /*
{
  name: "paymentIntentId",
  label: "Actions",
  options: {
    customBodyRender: (value) => {
      if (!value) return null; // or return a disabled button, placeholder, etc.

      return (
        <IconButton onClick={() => handleOpen(value)} color="primary">
          <SearchIcon />
        </IconButton>
      );
    }
  }
}*/


];

  const options = {
    filter: true,
    filterType: "dropdown",
    selectableRows: "none",
    responsive: "standard",
    downloadOptions: {
      filename: 'GlobalFoundry_pagos.csv'
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
    
    customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage, textLabels) => {
      const totalAmount = data.reduce((sum, row) => sum + row.amount, 0); // Calculate total
      const formattedTotal = new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(totalAmount); // Format as MXN

      return (
        <div style={{ padding: "16px", fontWeight: "bold", textAlign: "right" }}>
          Total: {formattedTotal}
        </div>
      );
    },
 };

 // option
const downloadOptions = {
  filename: "excel-format.csv",
  separator: ";",
  filterOptions: {
  useDisplayedColumnsOnly: true,
  useDisplayedRowsOnly: true,
  }
}
  
const onDownload = (buildHead, buildBody, columns, data) => {
  return "\uFEFF" + buildHead(columns) + buildBody(data); 
} 

  //console.log(className);
  //console.log(users);
 
  const classes = useStyles();

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [data, setData] = useState([]);   

  useEffect(() => {
    const GetData = async () => {
      try {
        const result = await axios.get("/api/pagos");
        console.log(result.data);
        setData(result.data);
      } catch (error) {
        console.error("Error fetching pagos:", error);
      }
    };

    GetData();
  }, []);
		

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };

  /*
  onDownload: (buildHead, buildBody, columns, data) => {
    return "\uFEFF" + buildHead(columns) + buildBody(data);
  }
*/

  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const handleOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedId(null);
  };


  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
          <MUIDataTable
                data={data || []}
                columns={columns}
                options={options}
            />
          </div>
        </PerfectScrollbar>
              <Modal open={open} onClose={handleClose}>
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: 400, bgcolor: "background.paper", boxShadow: 24, p: 4 }}>
          <Typography variant="h6">Detalles de la Transacción</Typography>
          <Typography variant="body1">Transaction ID: {selectedId}</Typography>
          <Button onClick={handleClose} sx={{ mt: 2 }} variant="contained" color="primary">Cerrar</Button>
        </Box>
      </Modal>
      </CardContent>
    </Card>
  );
};

PagosTable.propTypes = {
  className: PropTypes.string
};

export default PagosTable;